import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { fetchData } from "../../helpers/getData/fetchData";
import { EditOportunity } from "./EditOportunity";
import { Loading } from "../generals/Loading";

export const EditOportunityWrapper = ({
  setHidden,
  setReloadData,
  vehiclesList,
  name,
}) => {
  const { t } = useTranslation("global");
  const [userList, setuserList] = useState("isLoading");

  useEffect(() => {
    fetchData(setuserList, `/user`, t);
  }, [t]);

  if (userList === "isLoading") {
    return <Loading />;
  }

  return (
    <EditOportunity
      setHidden={setHidden}
      setReloadData={setReloadData}
      vehiclesList={vehiclesList}
      name={name}
      userList={userList?.filter(
        (user) => user.role === "Club" || user.role === "Híbrido"
      )}
    />
  );
};
